// spotlight.component.ts
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SpotlightService } from '../services/spotlight.service';
import { Rectangle } from '../services/text-control.service.interface';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { cloneDeep } from 'lodash';
@Component({
  selector: 'app-spotlight',
  template: `
    <div *ngIf="spotlight">
      <div
        [@spotlightAnimation]="{
          value: animationState,
          params: {
            left: spotlight.location.x,
            top: spotlight.location.y,
            width: spotlight.size.width,
            height: spotlight.size.height
          }
        }"
        [ngStyle]="{
          position: 'absolute',
          'border-radius': '30%',
          'box-shadow': 'rgba(0, 0, 0, 0.5) 0px 0px 2000px 5000px, rgba(0, 0, 0, 0.5) 0px 0px 10px 10px inset',
          'transform-origin': 'center'
        }"></div>
    </div>
  `,
  animations: [
    trigger('spotlightAnimation', [
      state(
        'active',
        style({
          left: '{{left}}px',
          top: '{{top}}px',
          width: '{{width}}px',
          height: '{{height}}px',
          transform: 'scale(1)',
          'transform-origin': 'center',
        }),
        { params: { left: 0, top: 0, width: 0, height: 0 } }
      ),
      state(
        'inactive',
        style({
          left: '{{left}}px',
          top: '{{top}}px',
          width: '{{width}}px',
          height: '{{height}}px',
          transform: 'scale(1)',
          'transform-origin': 'center',
        }),
        { params: { left: 0, top: 0, width: 0, height: 0 } }
      ),
      transition('active <=> inactive', [animate('150ms ease-in-out')]),
    ]),
  ],
})
export class SpotlightComponent implements OnInit {
  spotlight: Rectangle | null = null;
  animationState = 'active';

  constructor(private spotlightService: SpotlightService, private changeDetectorRef: ChangeDetectorRef) {}
  ngOnInit(): void {
    this.spotlight = { location: { x: 0, y: 0 }, size: { width: 0, height: 0 } };
    this.spotlightService.spotlight$.subscribe((spotlight) => {
      this.spotlight = cloneDeep(spotlight);
      this.animationState = this.animationState === 'active' ? 'inactive' : 'active';
      this.changeDetectorRef.markForCheck();
      this.changeDetectorRef.detectChanges();
    });
  }
}
